import React from 'react';
import { AppBar, Toolbar } from '@material-ui/core';
import { Link } from 'react-router-dom';
import NavLinks from './NavLinks';
import themeService from '../themes/themeService';

const { palette } = themeService.getTheme();

const styles = {
    root: {
        flexGrow: 1,
        marginLeft: -12,
        marginRight: -12,
        background: palette.secondary.main
    },
    heading: {
        flexGrow: 1,
    },
    headingText: {
        fontSize: '1.75rem',
        letterSpacing: '.1em',
        color: palette.primary.light,
        textDecoration: 'none'
    },
};

export default function HeaderAppBar(props) {
    const { isAuthenticated, setIsAuthenticated } = props;
    return (
        <div style={styles.root}>
            <AppBar
                position="static"
                color="secondary"
                className={`nav-bar ${isAuthenticated ? 'hidden' : ''}`}>
                <Toolbar>
                    <div style={styles.heading}>
                        <Link style={styles.headingText} to='/'>{themeService.getTitle()}</Link>
                    </div>
                    {isAuthenticated ? <NavLinks style={styles.headingText} setIsAuthenticated={setIsAuthenticated}/> : null}
                </Toolbar>
            </AppBar>
        </div>);
}